module.exports = __webpack_public_path__ + "img/72.5.COD.d5ad8cfc.png";